import { graphql } from "@/data-access/graphql";

// ============================================================================
// Broadcast Clips
// ============================================================================

/**
 * Station fields for a broadcast clip result.
 */
export const BroadcastClipStationFragment = graphql(`
  fragment BroadcastClipStationFragment on BroadcastStationType @_unmask {
    id
    name
    primaryLanguage
    mediaType
    locationDisplay
    network
  }
`);

/**
 * Program fields for a broadcast clip result.
 */
export const BroadcastClipProgramFragment = graphql(`
  fragment BroadcastClipProgramFragment on BroadcastProgramType @_unmask {
    id
    title
    category
    programType
  }
`);

// ============================================================================
// Narrative Clusters
// ============================================================================

/**
 * Narrative cluster table row stats (FeedStats from storiesTable).
 */
export const NarrativeClusterStatsFragment = graphql(`
  fragment NarrativeClusterStatsFragment on FeedStats @_unmask {
    averageArticleImpact
    averageImpactStrength
    features
    grossImpact
    grossNegativeImpact
    grossNeutralImpact
    grossPositiveImpact
    headlines
    netImpactScore
    netSentiment
    passingMentions
    readership
    socialEngagement
    tier1
    tier2
    tier3
    totalMentions
    negativeMentions
    neutralMentions
    positiveMentions
  }
`);

/**
 * Narrative cluster row fields for discovery narrative clusters table.
 * Minimal fields needed for table display; omit unused StoryType fields.
 */
export const NarrativeClustersTableRowFragment = graphql(
  `
    fragment NarrativeClustersTableRowFragment on StoryType @_unmask {
      id
      name
      aggregatedImpact
      volume
      stats {
        ...NarrativeClusterStatsFragment
      }
    }
  `,
  [NarrativeClusterStatsFragment],
);
